import { render } from "./ViewToggle.vue?vue&type=template&id=67b4ae7e"
import script from "./ViewToggle.vue?vue&type=script&lang=js"
export * from "./ViewToggle.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__